
export const API_BASE_URL = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') 
    ? "http://localhost:8080/m" 
    : "https://myslnazdrowie.pl/api2/m";

export const WELCOME_PAGE_URL = "https://myslnazdrowie.pl";